<template>
  <div class="flex h-full overflow-y-hidden">
    <div class="min-w-64 overflow-visible">
      <h2 class="font-bold pl-5 pt-8">Settings</h2>
      <settings-list @label-selected="updateSettingsSectionTitle" />
    </div>

    <shadowed-wrapper class="w-full">
      <router-view></router-view>
    </shadowed-wrapper>
  </div>
</template>

<script>
import ShadowedWrapper from '@/components/base-components/ShadowedWrapper.vue'
import SettingsList from '@/components/settings/SettingsList.vue'

export default {
  name: 'Settings',

  metaInfo() {
    return { title: `${this.settingsSectionTitle} | Settings` }
  },

  components: { SettingsList, ShadowedWrapper },

  data() {
    return {
      settingsSectionTitle: 'Bots'
    }
  },

  methods: {
    updateSettingsSectionTitle(title) {
      this.settingsSectionTitle = title
    }
  }
}
</script>

